// Resolve a "target string" de um passo de tour para um elemento real no DOM.
// Formatos suportados:
//   nav=/rota     → item da sidebar (link com href)
//   text=Rótulo   → botão/link/[role=button] cujo texto contém "Rótulo"
//   css=seletor   → seletor CSS cru
//   <seletor>     → tratado como CSS cru
export function resolveTarget(target?: string): HTMLElement | null {
  if (!target) return null;

  try {
    if (target.startsWith('nav=')) {
      const href = target.slice(4);
      return document.querySelector<HTMLElement>(`aside a[href="${href}"]`);
    }

    if (target.startsWith('text=')) {
      const label = target.slice(5).trim().toLowerCase();
      const candidates = Array.from(
        document.querySelectorAll<HTMLElement>('button, a, [role="button"]'),
      ).filter((el) => el.offsetParent !== null); // só visíveis
      // match exato primeiro, depois "contém"
      const exact = candidates.find(
        (el) => (el.textContent || '').trim().toLowerCase() === label,
      );
      if (exact) return exact;
      return (
        candidates.find((el) =>
          (el.textContent || '').trim().toLowerCase().includes(label),
        ) || null
      );
    }

    const selector = target.startsWith('css=') ? target.slice(4) : target;
    // querySelector pode ter múltiplos seletores separados por vírgula
    return document.querySelector<HTMLElement>(selector);
  } catch {
    return null;
  }
}
